import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import sreeRamImage from "../../assets/images/profile/Sree Ram.png";
import raviNamaImage from "../../assets/images/profile/Ravi Nama.png";
import radhaKrishnaImage from "../../assets/images/profile/Radha Krishna.png";

const LeadershipTeam = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const leaders = [
    {
      name: "Sree Ram",
      initial: "S",
      designation: "Director – IT Consulting, Delivery & Operations",
      gradient: "from-blue-500 to-blue-700",
      image: sreeRamImage,
    },
    {
      name: "Ravi Nama",
      initial: "R",
      designation: "Director – HR & Internal Operations",
      gradient: "from-indigo-500 to-indigo-700",
      image: raviNamaImage,
    },
    {
      name: "Radha Krishna",
      initial: "R",
      designation: "Executive Director – IT Consulting & Delivery",
      gradient: "from-purple-500 to-purple-700",
      image: radhaKrishnaImage,
    },
  ];

  return (
    <div className="w-full bg-gradient-to-br from-gray-50 via-white to-blue-50 py-12 md:py-16 lg:py-20 px-4 md:px-6 lg:px-12 relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 md:bottom-20 right-4 md:right-10 w-64 md:w-96 h-64 md:h-96 bg-indigo-500 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Title Heading */}
        <h2
          className="text-5xl md:text-6xl font-extrabold text-center mb-6 bg-gradient-to-r from-gray-900 via-blue-800 to-gray-900 bg-clip-text text-transparent tracking-tight"
          data-aos="fade-down"
        >
          Leadership Team
        </h2>

        {/* Sub-heading */}
        <p
          className="text-xl md:text-2xl text-center text-gray-600 mb-16 max-w-3xl mx-auto font-light leading-relaxed"
          data-aos="fade-up"
        >
          Meet our experienced leadership team driving innovation and excellence
        </p>

        {/* Profile Cards Grid */}
        <div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 justify-items-center"
          data-aos="fade-up"
        >
          {leaders.map((leader, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl p-10 w-full max-w-sm flex flex-col items-center text-center transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 hover:border-blue-200 relative overflow-hidden"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              {/* Card gradient overlay on hover */}
              <div className={`absolute inset-0 bg-gradient-to-br ${leader.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-500`}></div>
              
              {/* Top accent border */}
              <div className={`absolute top-0 left-0 right-0 h-1 bg-gradient-to-r ${leader.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-500`}></div>

              <div className="relative z-10 w-full">
                {/* Avatar Circle with profile image */}
                <div className="relative w-32 h-32 mb-8 mx-auto shadow-xl group-hover:shadow-2xl group-hover:scale-110 transition-all duration-500 rounded-full overflow-hidden">
                  <img
                    src={leader.image}
                    alt={`${leader.name} Profile`}
                    className="w-full h-full rounded-full object-cover border-4 border-blue-500 group-hover:border-blue-600 transition-all duration-500"
                  />
                </div>

                {/* Name with enhanced typography */}
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 tracking-tight group-hover:text-gray-800 transition-colors duration-300">
                  {leader.name}
                </h3>

                {/* Designation with improved styling */}
                <div className="h-px w-16 bg-gradient-to-r from-transparent via-gray-300 to-transparent mx-auto mb-4 group-hover:w-24 transition-all duration-500"></div>
                
                <p className={`text-base md:text-lg font-semibold bg-gradient-to-r ${leader.gradient} bg-clip-text text-transparent leading-relaxed`}>
                  {leader.designation}
                </p>
              </div>

              {/* Decorative corner elements */}
              <div className="absolute top-4 right-4 w-2 h-2 bg-blue-200 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="absolute bottom-4 left-4 w-2 h-2 bg-indigo-200 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LeadershipTeam;

